import Param from '../../param';

const param = new Param();

export default class tabManager{
    constructor(){

        /* 必要なDOM */
        this.trigger = document.querySelectorAll('.js__tab');
        this.content = document.querySelectorAll('.js__tab__content');

        this.target = 0;

        TweenMax.set(this.content[0],{
            display:'block',
            opacity:1
        });

    }
    init() {

        let _length = this.trigger.length;
        for(var i = 0 ; i < _length ; i++){
            let _index = i;
            this.trigger[i].onclick = () => {
                this.target = _index;
                this.change();
                this.active();
            };
        }

    }

    change() {

        TweenMax.to(this.content, 0.3 ,{
            alpha: 0,
            ease : Power2.easeOut,
            onComplete:() => {
                TweenMax.set(this.content, {
                    display: 'none',
                });
                TweenMax.set(this.content[this.target], {
                    display: 'block',
                    onComplete:() => {
                        TweenMax.to(this.content, 0.3 , {
                            alpha: 1,
                            ease : Power2.easeIn,
                            onComplete: function(){
                                if(param.browserType === 'IE'){
                                    let event = document.createEvent('Event');
                                    event.initEvent('resize', true, true);
                                    window.dispatchEvent(event);
                                }else {
                                    window.dispatchEvent(new Event('resize')); //スムーススクロールのl-rootの高さ再取得のためリサイズイベントを走らせる
                                }
                            },
                        });
                    }
                });
            }
        });

    }

    active() {
        let _length = this.trigger.length;
        for(var i = 0 ; i < _length ; i++) {
            this.trigger[i].classList.remove('is-active');
        }
        this.trigger[this.target].classList.add('is-active');
    }

}
